import { NumberedList } from '@/pages/AnalysisResult/components';

import { toNumberedListItems, type RawTitleDescription } from '../lib';
import { useTranslation } from 'react-i18next';

interface AdjacentAudiencesProps {
  adjacentAudiences?: RawTitleDescription[];
}

export const AdjacentAudiences = ({ adjacentAudiences }: AdjacentAudiencesProps) => {
  const { t } = useTranslation('analysis');

  const items = toNumberedListItems(adjacentAudiences);

  if (!items.length) return null;

  return (
    <NumberedList
      title={t('analysisResult.adjacentAudiences.adjacentAudiences')}
      subtitle={t('analysisResult.adjacentAudiences.reachablePoolsOutsideTheSubscriberBase')}
      items={items}
    />
  );
};
